module.exports = __webpack_public_path__ + "img/search-icon.1abdce27.svg";